import produce from "immer";
import { initialState } from "./initialState";
import * as types from "./types";

const conceptReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.LOAD_ARTICLES:
        draft.articles = action.articles;
        draft.loading = false;
        break;
      case types.LOAD_TOTAL:
        draft.totalAmount = action.total;
        break;
      case types.LOAD_SUB_TOTAL:
        draft.articles = action.articles;
        draft.selectedArticles = action.selArticles;
        break;
      case types.SELECTED_ITEM:
        draft.selectedArticles = action.articles;
        break;
      case types.GENERATE_TOTAL:
        draft.totalAmount = draft.totalAmount + action.value;
        break;
      case types.LOAD_PAYMENT_REQUEST:
        draft.payment = action.payment;
        break;
      case types.LOAD_CAPTCHA:
        draft.captcha = action.captcha;
        break;
      case types.LOAD_INTERNAL_ID:
        draft.internalId = action.internalId;
        break;
      case types.RESET_STORE:
        draft.internalId = initialState.internalId;
        draft.captcha = initialState.captcha;
        draft.payment = initialState.payment;
        draft.totalAmount = initialState.totalAmount;
        draft.selectedArticles = initialState.selectedArticles;
        break;
    }
  });

export default conceptReducer;
